export default __webpack_public_path__ + "static/media/worker-uses-control-joystick-factory.bfc707cb.webp";